<script setup>
// Aviso pro CLIENTE de que o período está sendo calculado agora — fora do
// histórico pré-calculado (Reports::HourlyRollup) — e pode demorar. Uma linha
// neutra, sem jargão e sem o motivo: o motivo técnico (`coverage.reason`) é da
// equipe e fica no log do servidor ("na fonte") e no JSON. Decisão de
// 28/10/2026: aviso técnico em âmbar em toda tela de relatório ia virar
// reclamação de cliente nas madrugadas depois do deploy.
//
// Verificação da cobertura que falhou (`{ failed: true }`) mostra a MESMA
// linha: não sabemos se o período sai do agregado, então pode demorar — dizer
// isso é verdade; ficar mudo esconderia a falha.
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  coverage: {
    type: Object,
    default: null,
  },
});

const { t } = useI18n();

const visible = computed(() =>
  Boolean(props.coverage?.counted_live || props.coverage?.failed)
);
</script>

<template>
  <p v-if="visible" class="flex items-center gap-1.5 text-xs text-n-slate-11">
    <span class="i-lucide-clock size-3.5 shrink-0" />
    {{ t('REPORT.LIVE_COUNT_SHORT') }}
  </p>
</template>
